var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconPlayVideoComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'mag-seller';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-PlayVideo").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("circle", { cx: "18", cy: "18", r: "17.5", fill: useCurrentColor ? 'currentColor' : '#000', fillOpacity: ".2", stroke: "#fff" }),
        React.createElement("path", { d: "M14 12.8217C14 12.0326 14.8712 11.5544 15.5369 11.978L23.6742 17.1563C24.2917 17.5493 24.2917 18.4507 23.6742 18.8437L15.5369 24.022C14.8712 24.4456 14 23.9674 14 23.1783V12.8217Z", fill: useCurrentColor ? 'currentColor' : '#fff' }));
}
var IconPlayVideo = React.forwardRef(IconPlayVideoComponent);
export default IconPlayVideo;
